import { atom } from 'jotai';

import { inventoryTagDetailQueryAtom } from '../_graphql/queryInventoryTag';

import { atomFromQueryString, atomFromRoutePath } from '~/shared/state';

export const $routeParams = atomFromRoutePath('/inventory/tags/:tagId');

export const $allocationsLimit = atomFromQueryString.number('limit', 25);
export const $allocationsOffset = atomFromQueryString.number('offset', 0);

export const $tagId = atom((get) => {
  const params = get($routeParams);
  return params.__didMatch ? params.tagId : undefined;
});

export const $addMovementsDialogOpen = atom(false);
export const $editDialogOpen = atom(false);

export const $remoteTagDetail = inventoryTagDetailQueryAtom((get) => {
  const tagId = get($tagId);
  const allocationsLimit = get($allocationsLimit);
  const allocationsOffset = get($allocationsOffset);

  if (!tagId) {
    return {
      variables: {
        id: '',
        allocationsLimit: 25,
        allocationsOffset: 0,
      },
      skip: true,
    };
  }

  return {
    variables: {
      id: tagId,
      allocationsLimit,
      allocationsOffset,
    },
    skip: false,
  };
});
